export default "/kiban/_next/static/images/design-d4f51470a24a30b45496374b736d4baf.png";